/* eslint-disable max-len */
import UAParser from 'ua-parser-js';
import React, { Component } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Link,
  Typography,
} from '@material-ui/core';
import { ExpandMore, Help } from '@material-ui/icons';

import Image from 'Elements/Image';
import styles from './styles.scss';

class PermissionsHelper extends Component {
  constructor(props) {
    super(props);
    this.parsedUA = new UAParser().getResult();
    this.state = {
      isExpanded: false,
    };
  }

  toggelPanel = () => {
    this.setState((prevState) => ({
      isExpanded: !prevState.isExpanded,
    }));
  }

  handleReload = () => {
    window.location.reload();
  }

  renderHelperInformation = () => {
    if (this.parsedUA.os.name === 'iOS') {
      return (
        <React.Fragment>
          <Typography variant='body1'>
            To allow access to your microphone and camera follow these steps. You can skip the first two steps by clicking on the following links:
          </Typography>
          <Typography variant='body1'>
            <Link
              color='secondary'
              href='prefs:root=SAFARI&path=Camera'
              rel='noreferrer'
              target='_blank'
            >
              Camera permission settings
            </Link>{' | '}
            <Link
              color='secondary'
              href='prefs:root=SAFARI&path=Microphone'
              rel='noreferrer'
              target='_blank'
            >
              Microphone permission settings
            </Link>
          </Typography>
          <ol>
            <li>
              <Typography component='span' variant='body1'>
                Open <strong>Settings</strong>, then its <strong>Safari</strong> tab.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Scroll down and tap on <strong>Camera</strong> under <strong>Settings for websites</strong>.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Change access on all websites to <strong>Ask</strong>.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Then reload the page or tap here to <Link color='secondary' onClick={this.handleReload}>reload</Link>.
              </Typography>
            </li>
          </ol>
        </React.Fragment>
      );
    } else if (this.parsedUA.browser.name === 'Safari') {
      return (
        <React.Fragment>
          <Typography variant='body1'>
            To allow access to your microphone and camera follow these steps:
          </Typography>
          <ol>
            <li>
              <Typography component='span' variant='body1'>
                Open the <strong>Safari settings</strong>, then its <strong>Websites</strong> tab.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Select <strong>Camera</strong> in the left General panel.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Find <strong>teleconsult.geniesolutsion.com.au</strong> in the list of <strong>Currently Open Websites</strong>.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Change its option to Ask or <strong>Allow</strong>.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Repeat steps 3 and 4 for the <strong>Microphone</strong> section in the left General panel.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Then reload the page or click here to <Link color='secondary' onClick={this.handleReload}>reload</Link>.
              </Typography>
            </li>
          </ol>
          <Image
            classes={{ root: styles.helperImages }}
            src='/img/permissions-safari-desktop.png'
          />
        </React.Fragment>
      );
    } else if (this.parsedUA.browser.name === 'Firefox') {
      return (
        <React.Fragment>
          <Typography variant='body1'>
            To allow access to your microphone and camera follow these steps:
          </Typography>
          <ol>
            <li>
              <Typography component='span' variant='body1'>
                Click on the <strong>Padlock icon</strong> in the browser address bar.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Click on the <strong>“&times;”</strong> button next to the blocked Camera and/or Microphone permission.
              </Typography>
            </li>
            <li>
              <Typography component='span' variant='body1'>
                Then reload the page or click here to <Link color='secondary' onClick={this.handleReload}>reload</Link>.
              </Typography>
            </li>
          </ol>
          <Image
            classes={{ root: styles.helperImages }}
            src='/img/permissions-firefox-desktop.png'
          />
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Typography variant='body1'>
          To allow access to your microphone and camera follow these steps:
        </Typography>
        <ol>
          <li>
            <Typography component='span' variant='body1'>
              Click on the <strong>Padlock icon</strong> in the browser address bar.
            </Typography>
          </li>
          <li>
            <Typography component='span' variant='body1'>
              Select <strong>Allow</strong> from the dropdown next to the Camera and/or Microphone permission.
            </Typography>
          </li>
        </ol>
        <Image
          classes={{ root: styles.helperImages }}
          src='/img/permissions-chrome-desktop.png'
        />
      </React.Fragment>
    );
  }

  render() {
    const {
      isExpanded,
    } = this.state;
    return (
      <ExpansionPanel
        classes={{ root: styles.permissionsHelperWrapper }}
        expanded={isExpanded}
        onChange={this.toggelPanel}
      >
        <ExpansionPanelSummary
          classes={{ root: styles.summary }}
          expandIcon={<ExpandMore />}
        >
          <Help />
          <Typography variant='body1'><strong>How to grant access</strong></Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div>
            {this.renderHelperInformation()}
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

export default PermissionsHelper;
